import styled from "styled-components";

import { SubHeading } from "style/components/SubHeading.styles";
import { Button } from "components/Button";

export const AccountContainer = styled.div`
  .profile-wrapper {
    .header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      h2 {
        margin-bottom: 0;
      }

      .btn-back {
        margin-right: 20px;
        margin-bottom: 0;
      }
    }

    .account {
      .name {
        color: ${({ theme }) => theme.global.color.arrow};
        font-size: 24px;
        font-weight: 400;
        text-transform: capitalize;
        margin: 0px;
      }
      .profile-information {
        .input-form {
          .input-form-field {
            margin-bottom: 15px;
            background: transparent;
            color: ${({ theme }) => theme.card.font.tertiary};

            &:disabled {
              background: ${({ theme }) => theme.table.bg.color?.primary};
              color: ${({ theme }) => theme.card.font.tertiary};
              width: 100%;
            }
          }
          .input-form-field::placeholder,
          .input-form-field-description::placeholder {
            color: ${({ theme }) => theme.input.placeholder.color};
          }
          .input-form-field-description {
            border-radius: 10px;
          }
        }

        .profile-menu {
          background-color: ${({ theme }) => theme.card.bg.septenary};
          border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};

          .nav-link {
            font-weight: 600;
            font-size: 14px;
            line-height: 140%;
            color: ${({ theme }) => theme.global.color.quaternary};
            padding: 1.2rem 1rem;
            display: flex;
            align-items: center;

            &.active {
              color: ${({ theme }) => theme.nav.font.color};

              .icon {
                opacity: 1;
              }
            }

            .icon {
              margin-right: 30px;
              margin-left: 20px;
              opacity: 0.5;
              width: 30px;
              display: inline-block;
            }
          }

          .divider {
            margin: 0.2em 0;
          }
        }

        .content-wrapper {
          backdrop-filter: blur(25px);
          border-radius: 10px;
        }
      }

      .profile-header {
        gap: 16px;

        .img-profile-col {
          height: 110px;
          width: 110px;
          display: flex;
          justify-content: center;
          align-items: center;

          .img-profile {
            height: 88px;
            width: 88px;
            border-radius: 50%;
            position: relative;
            border: 1px solid ${({ theme }) => theme.card.border.quaternary};
            padding: 5px;

            .icon-camera {
              bottom: 0;
              right: 5px;
              position: absolute;
              border-radius: 50%;
              background: #048af5;
              height: 25px;
              width: 25px;
              display: none;
            }

            .profile {
              border-radius: 50%;
              height: 100%;
              width: 100%;
            }

            .user-icon {
              background-color: ${({ theme }) => theme.global.color.highlights};
              color: #fff;
              font-weight: 500;
              border-radius: 50%;
              height: 100%;
              width: 100%;
              justify-content: center;
              display: flex;
              align-items: center;
              font-size: 30px;
            }
          }
        }

        .details-col {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

          .email {
            color: ${({ theme }) => theme.tab.color.quinary};
            font-size: 16px;
            font-weight: 400;
          }
        }

        .upload-btn-col {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;

          .upload-btn {
            font-weight: 500;
            font-size: 14px;
          }
        }

        .plan-box {
          display: flex;
          padding: 12px 8px;
          border: 2px solid #157bfb;
          border-radius: 4px;
          align-items: center;
          margin-bottom: 15px;

          img {
            background: #157bfb;
            margin-right: 8px;
            padding: 4px;
            width: 25px;
            height: 25px;
            border-radius: 8px;
          }

          .label {
            color: ${({ theme }) => theme.global.color.senary};
            font-weight: 500;
            font-size: 0.85em;
            margin-right: 8px;
          }

          .value {
            border-radius: 8px;
            border: 1px solid #e3e3e8;
          }
        }

        .my-subcription {
          font-weight: 700;
          font-size: 15px;
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .profile-wrapper {
      .account {
        .profile-header {
          h2 {
            font-size: 18px;
          }

          .upload-btn-col {
            display: none;
          }

          .img-profile-col {
            height: 70px;
            width: 70px;
            margin-left: 6px;

            .img-profile {
              height: 70px;
              width: 70px;

              .user-icon {
                height: 58px;
                width: 55px;
              }
            }

            .img-profile .icon-camera {
              display: block;
              height: 20px;
              width: 20px;
            }
          }
        }

        .profile-information {
          padding: 0;

          .profile-menu {
            display: none;
          }
          .content-wrapper {
            padding-left: 0;

            h2 {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
`;

export const FormSubmitButton = styled(Button)`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
`;

export const BodyHeading = styled(SubHeading)`
  color: ${({ theme }) => theme.global.color.senary} !important;
  text-align: center;
  margin-bottom: 2.5rem;
`;
